import { CardSize } from "Shared/Components";

export const GetCardWidthAndHeightFromCardSize = (cardSize: CardSize | { width: number; height: number } | undefined): { width: number; height: number } => {
    if (typeof cardSize === "object") {
        return cardSize;
    }

    switch (cardSize) {
        case CardSize.ExtraSmall:
            return { width: 3, height: 2 };
        case CardSize.Medium:
            return { width: 6, height: 3 };
        case CardSize.Large:
            return { width: 8, height: 3 };
        case CardSize.ExtraLarge:
            return { width: 12, height: 4 };
        case CardSize.Small:
            return { width: 4, height: 2 };
        default:
            return { width: 4, height: 2 };
    }
};

export const GetCardSizeFromWidth = (width: number): CardSize => {
    if (width <= 3) {
        return CardSize.ExtraSmall;
    }
    if (width <= 4) {
        return CardSize.Small;
    }
    if (width <= 6) {
        return CardSize.Medium;
    }
    if (width <= 8) {
        return CardSize.Large;
    }
    return CardSize.ExtraLarge;
};

export const ColumnsForLargeScreen = 12;
export const ColumnsForSmallScreen = 2;
